module.exports = __webpack_public_path__ + "img/twister.57a280cd.png";